import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

export interface RecentLogEntry {
  id: number;
  foodId: number;
  logDate: string;
  mealSlot: string;
  quantityG: number;
  servings: number | null;
  notes: string | null;
  food: {
    id: number;
    foodName: string;
    brand: string | null;
    category: string | null;
    servingSizeG: number | null;
    nutrients71: string | null;
    translations: Record<string, string> | null;
  } | null;
}

export function useRecentLogs(limit = 10) {
  return useQuery<RecentLogEntry[]>({
    queryKey: ["/api/logs/recent", limit],
    queryFn: () => apiFetch<RecentLogEntry[]>(`/logs/recent?limit=${limit}`),
    staleTime: 30_000,
  });
}

export interface FrequentLogEntry {
  foodId: number;
  logCount: number;
  lastLogged: string;
  food: RecentLogEntry["food"];
}

export function useFrequentLogs(limit = 20, days = 30) {
  return useQuery<FrequentLogEntry[]>({
    queryKey: ["/api/logs/frequent", limit, days],
    queryFn: () =>
      apiFetch<FrequentLogEntry[]>(`/logs/frequent?limit=${limit}&days=${days}`),
    staleTime: 5 * 60_000,
  });
}
